import { isAndroid, isIOS } from "./platform";

export const applyGlobalPolyfills = () => {
	if (isIOS || isAndroid) {
		const {
			polyfill: polyfillBase64,
		} = require("react-native-polyfill-globals/src/base64");
		const {
			polyfill: pollyfillCrypto,
		} = require("react-native-polyfill-globals/src/crypto");

		polyfillBase64();
		pollyfillCrypto();

		if (!(globalThis as { structuredClone?: unknown }).structuredClone) {
			const sc = require("@ungap/structured-clone");
			(globalThis as { structuredClone: unknown }).structuredClone =
				sc.default ?? sc;
		}
		if (!(globalThis as { TextEncoderStream?: unknown }).TextEncoderStream) {
			const {
				TextEncoderStream,
				TextDecoderStream,
			} = require("@stardazed/streams-text-encoding");
			(globalThis as { TextEncoderStream: unknown }).TextEncoderStream =
				TextEncoderStream;
			(globalThis as { TextDecoderStream: unknown }).TextDecoderStream =
				TextDecoderStream;
		}
	}
};
